var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 569,
    viewBox: "0 0 1440 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_544_2939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.72 307.391C368.493 351.389 -28.6543 355.604 -28.6543 355.604L-28.6543 235.185L630.72 307.391Z",
    fill: "url(#paint0_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-28.6543 568.232L1492.63 568.233L1492.63 83.0178L-28.6543 83.0177L-28.6543 568.232Z",
    fill: "url(#paint1_radial_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.6543 568.232L1492.63 568.233L1492.63 83.0178L-28.6543 83.0177L-28.6543 568.232Z",
    fill: "url(#paint2_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.23 338.296C1166.51 327.114 943.444 398.084 650.539 404.096C357.633 410.109 75.9837 343.185 -29.3672 343.185L-29.3672 269.124L1372.46 283.622L1414.23 338.296Z",
    fill: "url(#paint3_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.572 295.76C986.409 293.961 1330.05 381.283 1492.63 381.283L1492.63 232.825L742.572 295.76Z",
    fill: "url(#paint4_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.63 287.668L1492.63 83.0185L-28.6543 83.0184L-28.6543 307.729C150.419 288.118 322.516 327.227 630.324 342.399C845.624 353.019 1036.27 325.879 1232.94 305.931C1233.81 305.818 1234.61 305.762 1235.48 305.65C1264.25 302.728 1293.19 299.974 1322.28 297.502C1327.83 297.052 1333.3 296.603 1338.85 296.153C1343.6 295.76 1348.44 295.367 1353.19 295.03C1356.92 294.749 1360.73 294.468 1364.45 294.187C1406.54 291.152 1449.19 288.792 1492.63 287.668Z",
    fill: "url(#paint5_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.73 83.0175C897.309 98.4702 582.524 155.224 306.028 155.224C205.433 155.224 76.3008 120.272 -29.3672 123.812L-29.3672 83.0174L1290.73 83.0175Z",
    fill: "url(#paint6_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M1290.73 83.0175C897.309 98.4702 582.524 155.224 306.028 155.224C205.433 155.224 76.3008 120.272 -29.3672 123.812L-29.3672 83.0174L1290.73 83.0175Z",
    fill: "url(#paint7_radial_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.3672 119.148L1492.63 119.149L1492.63 83.0735L-29.3672 83.0734L-29.3672 119.148Z",
    fill: "url(#paint8_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_544_2939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.568 313.214C358.674 369.091 -34.9395 374.443 -34.9395 374.443L-34.9394 221.512L618.568 313.214Z",
    fill: "url(#paint9_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-34.9395 644.482L1472.81 644.483L1472.81 28.2598L-34.9394 28.2597L-34.9395 644.482Z",
    fill: "url(#paint10_radial_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.9395 644.482L1472.81 644.483L1472.81 28.2598L-34.9394 28.2597L-34.9395 644.482Z",
    fill: "url(#paint11_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.46 377.308C1244.34 359.115 1005.6 474.578 692.12 484.36C378.64 494.142 77.2078 385.261 -35.543 385.261L-35.5429 264.77L1464.75 288.357L1509.46 377.308Z",
    fill: "url(#paint12_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.457 369.848C937.253 367.408 1300.56 485.877 1472.46 485.877L1472.46 284.465L679.457 369.848Z",
    fill: "url(#paint13_linear_544_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.63 283.989L1472.63 9.64851L-35.3672 9.64838L-35.3672 310.881C142.142 284.592 312.736 337.019 617.856 357.358C831.275 371.594 1020.26 335.212 1215.21 308.471C1216.07 308.32 1216.86 308.245 1217.72 308.094C1246.25 304.177 1274.93 300.486 1303.77 297.171C1309.27 296.569 1314.69 295.966 1320.19 295.364C1324.91 294.836 1329.7 294.309 1334.41 293.857C1338.11 293.48 1341.88 293.104 1345.57 292.727C1387.3 288.66 1429.57 285.496 1472.63 283.989Z",
    fill: "url(#paint14_linear_544_2939)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_544_2939",
    x1: 239.599,
    y1: 372.899,
    x2: 333.723,
    y2: 63.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_544_2939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(451.583 436.919) scale(1226.76 630.457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_544_2939",
    x1: 713.048,
    y1: 284.504,
    x2: 792.768,
    y2: 628.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_544_2939",
    x1: 669.917,
    y1: 409.8,
    x2: 705.648,
    y2: 74.7474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_544_2939",
    x1: 1107.5,
    y1: 384.27,
    x2: 1133.43,
    y2: 150.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_544_2939",
    x1: 535.672,
    y1: 499.992,
    x2: 716.025,
    y2: -75.2817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_544_2939",
    x1: 499.019,
    y1: 419.465,
    x2: 578.756,
    y2: 13.9575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_544_2939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257.171 147.294) rotate(5.70289) scale(247.542 55.758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E9F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_544_2939",
    x1: 731.633,
    y1: 84.9902,
    x2: 731.633,
    y2: 117.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_544_2939",
    x1: 230.926,
    y1: 396.409,
    x2: 376.22,
    y2: 23.1805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_544_2939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(441.026 485.463) scale(1215.85 806.205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E3F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_544_2939",
    x1: 720.295,
    y1: 85.272,
    x2: 718.337,
    y2: 523.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_544_2939",
    x1: 712.863,
    y1: 493.639,
    x2: 799.941,
    y2: -43.5455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296274,
    stopColor: "#F1F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4E0FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_544_2939",
    x1: 1065.28,
    y1: 489.933,
    x2: 1110.07,
    y2: 175.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBD9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_544_2939",
    x1: 524.033,
    y1: 568.62,
    x2: 828.412,
    y2: -149.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9FCFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_544_2939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1522,
    height: 567.536,
    fill: "white",
    transform: "matrix(1 8.6589e-08 8.82645e-08 -1 -29.3672 568.232)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_544_2939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1508.46,
    height: 720.77,
    fill: "white",
    transform: "matrix(1 8.6589e-08 8.82645e-08 -1 -35.6465 644.482)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg-2.66d02bc0843e32a41bfca1ba83b47734.svg";
export { ForwardRef as ReactComponent };